export function isSafari(): boolean {
    return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}

export function isIOS(): boolean {
    if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
        return true;
    }
    return Boolean(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
}

export function isHuawei(): boolean {
    return /HUAWEI|HarmonyOS/.test(navigator.userAgent);
}
